import { Toaster as SonnerToaster } from "sonner";

import { useThemeStore } from "@/stores/theme";

/**
 * Toast provider — Sonner with FlowStack-themed surfaces.
 *
 * Mounted once at the AppShell root. Call ``toast.success(...)`` /
 * ``toast.error(...)`` / ``toast.promise(...)`` from anywhere.
 */
export function Toaster(): JSX.Element {
  const theme = useThemeStore((s) => s.theme);
  return (
    <SonnerToaster
      richColors
      position="bottom-right"
      theme={theme === "system" ? "system" : theme}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border-subtle group-[.toaster]:shadow-md",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-surface-2 group-[.toast]:text-foreground",
        },
      }}
    />
  );
}
